import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import _ from 'lodash';
import MapMarker from '../marker';

export default Vue.component('edit-map', {
  template: require('./template.html'),
  mixins: [guid],
  computed: {
    ...mapGetters(['viewport']),
  },
  components: {
    MapMarker,
  },
  data() {
    return {
      pause: null,
      markers: [],
      selectedItem: 0,
      display: {
        showAddress: false,
      },
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValues();
      }
    },
  },
  name: 'edit-map',
  props: ['droplet', 'show-edit-bubble'],
  methods: {
    setInitialValues() {
      this.display.showAddress = this.droplet.showAddress;
    },
    changeSelectedMarker(i) {
      this.selectedItem = i;
    },
    async addMarker() {
      const payload = {};
      payload.drp = this.droplet;
      payload.marker = {
        _id: this.guid(),
        lat: 29.424025,
        lng: -98.484884,
        title: 'River Center Mall',
        markerImg: `${process.env.S3_ASSETS_URL}mock-images/icons/maps-default-pin.svg`,
        address: 'River Center Mall, San Antonio Tx',
      };
      this.$store.dispatch('addMapMarker', payload);
      this.setPause();
      this.selectedItem = 0;
    },
    setLocals(v) {
      this.$emit('set-display', v);
    },
    drzRevertData() {
      this.$emit('css-generator');
      this.$vnode.context.bindPlugin();
    },
    setPause(n) {
      const t = n || 250;
      clearTimeout(this.pause);
      this.pause = setTimeout(() => {
        this.$vnode.context.unBindPlugin();
        this.$vnode.context.bindPlugin();
      }, t);
    },
    async drzClickSave() {
      const markers = this.$refs.mapMarker;
      const addAll = [];
      if (markers.length > 0) {
        _.forEach(markers, (m) => {
          addAll.push(m.setAddress());
          addAll.push(m.setTitle());
        });
      }
      await Promise.all(addAll);
      // map needs a small buffer to rebind, even after the async run
      this.setPause();
    },
    promise(action, error) {
      const promise = new Promise((resolve, reject) => {
        if (action) {
          resolve();
        } else {
          reject(Error(`Error in map: ${error}`));
        }
      });
      promise.then(this.setPause);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/google-map/components/_edit-options/index.js